<template>
  <div>
    <van-field
      name="uploader"
      required
      label="识别头像"
      size="large"
      center
      label-width="120"
    >
      <template #input>
        <img
          src="@/assets/images/avatar.png"
          alt=""
          style="width: 2.75rem; height: 2.75rem;"
          @click="init"
        />
        <!-- <van-uploader
          :after-read="afterReadPerson"
          :before-delete="beforeDelPerson"
          v-model="addPersonFileList"
          :max-count="1"
          multiple
        >
          <img
            src="@/assets/images/avatar.png"
            alt=""
            style="width: 2.75rem; height: 2.75rem;"
          />
        </van-uploader> -->
      </template>
    </van-field>
    <img
      :src="avatar"
      alt=""
      style="width: 4rem; height: 4rem; border-radius: 50%;"
    />
  </div>
</template>

<script>
import wxSDK from '@/utils/wxSDK.service'
import assign from '@/mixins/assign'
import { infoClient } from '@/utils/oss'

export default {
  mixins: [assign],

  data() {
    return {
      avatar: '',
    }
  },
  methods: {
    async init() {
      await wxSDK.jsSDKConfig()
      const { localIds } = await wxSDK.chooseImage()
      const res = await wxSDK.getLocalImgData(localIds[0])
      // base64转file，上传oss
      const resp = await infoClient().put(res.name, res)
      // console.log('base64转file', res)

      console.log(resp)
      // await
    },
  },
}
</script>

<style lang="scss" scoped></style>
